import { OpenLinkButton } from '@ydistri/ds';
import { EntityListItemResponse } from '@ydistri/api-sdk';
import React from 'react';
import useCreateEntityListItemDetailLink from '../../hooks/useCreateEntityListItemDetailLink';

interface OpenEntityListItemLinkProps {
  item: EntityListItemResponse;
}

/**
 * Button to open the Detail screen with either a product or Sku detail
 * @param item - The entity list item representing either a product or Sku
 * @constructor
 */
const OpenEntityListItemLinkButton: React.FC<OpenEntityListItemLinkProps> = ({ item }) => {
  const link = useCreateEntityListItemDetailLink(item);

  if (link) {
    return <OpenLinkButton link={link} tooltip="Open detail" />;
  }
};

export default OpenEntityListItemLinkButton;
